module.exports = __webpack_public_path__ + "img/reward.bc46be56.jpg";